<div class="bz-trace-node-list-nodes" *ngIf="showNodes">
  <div *ngFor="let node of nodes | orderByTranslate : 'TRACE_CONFIGURATION.' : 'DisplayName' : true : true; let i = index" class="node-wrapper">
    <div class="bz-trace-node-list-nodes__node" (click)="viewChildren(node)"
      [ngClass]="{'bz-trace-node-list-nodes__node--pointer': node.Nodes && node.Nodes.length > 0}">

      <div  (click)="clickOnDropdown($event, node);" [title]="getTitle(node)" class="dropdown">
        <bzg-icon *ngIf="node.Level === 'Off'" [size]="14" class="bz-trace-node-list-nodes__node__icon"
          [nameIcon]="'icon-minus'">
        </bzg-icon>
        <bzg-icon *ngIf="node.Level === 'Warning'" class="bz-trace-node-list-nodes__node__icon"
          color="warning" [nameIcon]="'icon-warning'">
        </bzg-icon>
        <bzg-icon *ngIf="node.Level === 'Error'" class="bz-trace-node-list-nodes__node__icon"
          color="error" [nameIcon]="'icon-error'">
        </bzg-icon>
        <bzg-icon *ngIf="node.Level === 'Info'" class="bz-trace-node-list-nodes__node__icon" color="info"
          [nameIcon]="'icon-info-strong'">
        </bzg-icon>
      </div>

      <div class="bz-trace-node-list-nodes__node__container-text"
        [ngClass]="{'bz-trace-node-list-nodes__node__container-text--child' : node.Nodes && node.Nodes.length > 0}">
        <span>{{node.DisplayName | translate}} {{showMenu[i]}}</span>
      </div>

      <div class="bz-trace-node-list-nodes__node__container-collapse"
        [ngClass]="{'bz-trace-node-list-nodes__node__container-collapse--up':node.Selected}">
        <bzg-icon *ngIf="node.Nodes && node.Nodes.length > 0" [nameIcon]="'arrow-up-special'" [size]="16"
          [ngClass]="{'bz-icon-color--neutral-primary': node.Selected}">
        </bzg-icon>
      </div>
    </div>

    <div *ngIf="showDropdown(node)" class="menu" [ngStyle]="{'min-width':'170px'}" [ngClass]="{'menu': true, 'above': isMenuAbove(node)}">
      <div class="menu-item" (click)="setLevel('Off', i, node)">
        <bzg-icon [size]="14" class="bz-trace-node-list-nodes__menu-icon bz-space--inline-s" [nameIcon]="'icon-minus'">
        </bzg-icon>
        <span>{{ 'TRACE_CONFIGURATION.NONE' | translate }}</span>
      </div>
      <div class="menu-item" (click)="setLevel('Info', i, node)">
        <bzg-icon [size]="14" class="bz-trace-node-list-nodes__menu-icon bz-space--inline-s" color="info"
        [nameIcon]="'icon-info-strong'">
        </bzg-icon>
        <span>{{ 'TRACE_CONFIGURATION.INFO' | translate }}</span>
      </div>
      <div class="menu-item" (click)="setLevel('Warning', i, node)">
        <bzg-icon [size]="14" class="bz-trace-node-list-nodes__menu-icon bz-space--inline-s" color="warning"
          [nameIcon]="'icon-warning'">
        </bzg-icon>
        <span>{{ 'TRACE_CONFIGURATION.WARNING' | translate }}</span>
      </div>
      <div class="menu-item" (click)="setLevel('Error', i, node)">
        <bzg-icon [size]="14" class="bz-trace-node-list-nodes__menu-icon bz-space--inline-s" color="error" [nameIcon]="'icon-error'">
        </bzg-icon>
        <span>{{ 'TRACE_CONFIGURATION.ERROR' | translate }}</span>
      </div>
    </div>

    <div *ngIf="node.Nodes && node.Nodes.length > 0 && node.Selected" class="bz-trace-node-list-nodes__node--level-one">
      <biz-trace-node [nodes]="node.Nodes" [showMenuOption]="showMenuOption" [nameParent]="node.DataKeyString" (emitNodes)="getNodes($event)" (emitShowMenuOption)="getShowMenuOption($event)" ></biz-trace-node>
    </div>
  </div>
</div>

